export const INITIAL_PAGE_STATE = 1
export const INITIAL_PAGE_SIZE = 2000
export const PAGE_STEP = 1
